export enum AtcSegmentTargetGroup {
  HumanMedicines = 1,
  VeterinaryMedicines = 2,
  OtherMedicalProducts = 3
}

(AtcSegmentTargetGroup as any).__typeName = 'AtcSegmentTargetGroup';
